import { getBannerInfo, getDownloadAppBannerData } from "./bannerInfo";

const getLocationString = (locations: Array<{id: number; name: string}>) => {
  let locationMap = '';

  locations?.forEach((location, index) => {
    if (index > 0) {
      locationMap = `${locationMap}/${location?.name}`;
    } else {
      locationMap = location?.name;
    }
  });

  return locationMap;
};

/**
 *
 * @param key key of the cache
 * @param value value of the cache
 * @param ttl This is the time at which the cache will be discarded. This is relative time from current time in seconds.
 */
export function setItemWithExpiry(key: string, value: any, ttl: number): void {
  const expiry = Date.now() + ttl;
  const item = {value, expiry};
  localStorage.setItem(key, JSON.stringify(item));
}

export function getItemWithExpiry(key: string): any | null {
  const itemStr = localStorage.getItem(key);

  if (!itemStr) return null;

  const {value, expiry} = JSON.parse(itemStr);
  if (Date.now() > expiry) {
    localStorage.removeItem(key);
    return null;
  }
  return value;
}
export {getLocationString, getBannerInfo, getDownloadAppBannerData};
